import { useMsal } from "@azure/msal-react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Badge, Box, Checkbox, CircularProgress, IconButton, ListItemText, MenuItem, Popover, Select, TextareaAutosize } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { analyticsResultsGETEndipoint, editApproversWorkflowEndpoint, getLTPlannerHideColumnsEndpoint, getViewAllDetailsEndpoint, postLTPlannerHideColumnsEndpoint, reAssignToOthersEndpoint, recallPlannerEndpoint, rejectWorkflowEndpoint, reSubmitWorkflowEndpoint, sendForApprovalEndpoint, sendToLowMaterialsEndpoint } from "../../../common/endpoints";
import ButtonComponent from "../../../components/common/button/Button";
import Cards from "../../../components/common/card/Card";
import DataTable from "../../../components/common/datatable/DataTable";
import { Loader } from "../../../components/common/Loader";
import { getPlannerHideColumnsAPI } from "../../../redux/actions/HideColumns/GetPlannerHideColumns";
import { postPlannerHideColumnsAPI } from "../../../redux/actions/HideColumns/PostPlannerHideColumns";
import { getAnalyticsWorkflowResults } from "../../../redux/actions/LTPlanner/AnalyticsWorkflowResultsSlice";
import { postReassignToOthers } from "../../../redux/actions/LTPlanner/ReassignToOthersSlice";
import { postRejectWorkflow } from "../../../redux/actions/LTPlanner/RejectWorkflowSlice";
import { postResubmitWorkflow } from "../../../redux/actions/LTPlanner/ResubmitWorkflowSlice";
import { postSendForApproval } from "../../../redux/actions/LTPlanner/SendForApprovalSlice";
import { postSendLowMaterials } from "../../../redux/actions/LTPlanner/SendToS4MaterialsSlice";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import { ClosedWorkflowHeaders } from "../ColumnHeaders/ClosedWorkflowHeaders";
import { PendingActionHeaders } from "../ColumnHeaders/PendingActionHeaders";
import { PendingApprovalHeaders } from "../ColumnHeaders/PendingApprovalHeaders";
import LeadTimeLineGraph from "../LeadTimeLineGraph";
import OutBoundDataModal from "../OutBound/OutBoundDataModal";
import TopSection from "../TopSection";
import "./AnalyticsResults.css";
import { FinalLTUpdateModal } from "./FinalLTUpdateModal";
import LeadtimeModel from "./LeadTimeModal";
import { ReAssignModal } from "./ReAssignModal";
import { RejectWorkFlowItem } from "./RejectWorkFlow/RejectWorkFlowItem";
import { SendForApprovalModal } from "./SendForApprovalModal";
import { SendToS4Modal } from "./SendToS4/SendToS4Modal";
import CPLeadTimeModal from "../ContractPIRLeadTimeModal/CPLeadTimeModal";
import { putEditApproversWorkflow } from "../../../redux/actions/LTPlanner/EditApproversWorkflowSlice";
import { EditApproversModalNew } from "./EditApproversModalNew";
import { postRecallAPI } from "../../../redux/actions/LTPlanner/RecallSlice";
import { setSelectedItem } from "../../../redux/actions/SupportTicket/selectionSlice";
import { VariantViewModal } from "../VariantView/VariantViewModal";
import { ShowVariantViewModal } from "../VariantView/ShowVariantViewModal";
import TextInput from "../../../components/common/TextInput";

const AnalyticsResults = () => {
  const role = localStorage.getItem("LTRole");
  const userEmail = localStorage.getItem("data")
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSubmitToS4Enabled, setIsSubmitToS4Enabled] = useState([]);
  const [reCallDisabled, setReCallDisabled] = useState([]);
  const [rejectDisabled, setRejectDisabled] = useState(false);
  const [openFinalLTUpdateModal, setOpenFinalLTUpdateModal] = useState(false);
  const [activeItem, setActiveItem] = useState(localStorage.getItem("workflowActiveItem") || "Pending Action");
  const [editedRows, setEditedRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [bulkPDTValue, setBulkPDTValue] = useState("");
  const bulkPDTBaseRowsRef = useRef([]);
  const [bulkPDTDisabled, setBulkPDTDisabled] = useState(true);
  const { state } = useLocation();
  const location = useLocation();
  const gridRef = useRef();
  const currentPageRef = useRef(0);
  const [gridApi, setGridApi] = useState();
  const [openViewAllModal, setOpenViewAllModal] = useState(false);
  const [viewAllData, setViewAllData] = useState({});
  const [openLineGraph, setOpenLineGraph] = useState(false);
  const [lineGraphSelectedValue, setLineGraphSelectedValue] = useState(false);
  const [columnFilterDropdownOption, setColumnFilterDropdownOption] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [badgeCount, setBadgeCount] = useState();
  const [openCreateVariantModal, setOpenCreateVariantModal] = useState(false);
  const [openShowVariantModal, setOpenShowVariantModal] = useState(false);
  const [variantData, setVariantData] = useState({});
  const savedFilterModel = localStorage.getItem("savedVariantFilterModel");

  const [openOutboundModal, setOpenOutboundModal] = useState(false);
  const [outboundData, setOutboundData] = useState({});
  const [selectedName, setSelectedName] = useState("");

  const [leadTimeName, setLeadTimeName] = useState("");
  const [openLeadTimeModal, setOpenLeadTimeModal] = useState(false);
  const [leadTimeData, setLeadTimeData] = useState({});

  const [disableFilterBtn, setDisableFilterBtn] = useState(true);

  const { instance } = useMsal();
  const landingCardTitle = state || "";
  const variationRanking = landingCardTitle === "Medium LT Variation" ? { "High": 2, "Medium": 3, "Low": 1 } : landingCardTitle === "Low LT Variation" ? { "High": 2, "Medium": 1, "Low": 3 } : landingCardTitle === "High LT Variation" ? { "High": 3, "Medium": 2, "Low": 1 } : { "High": 3, "Medium": 2, "Low": 1 };

  const queryParams = new URLSearchParams(location?.search || "");
  const fromDetails = queryParams.get("fromDetails");

  useEffect(() => {
    getWorkFlowData();
  }, [])

  useEffect(() => {
    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage !== null) {
      currentPageRef.current = Number(savedPage);
    }
  }, []);
  useEffect(() => {
    if (typeof (fromDetails) !== "string") {
      localStorage.removeItem('agGridSharedFilter');
    }
  }, []);
  const checkVariantFilter = () => {
    if (!gridApi) return;

    if (savedFilterModel) {
      try {
        const parsedFilterModel = JSON.parse(savedFilterModel);
        gridApi.setFilterModel(parsedFilterModel);
        gridApi.onFilterChanged();
      } catch (e) {
        console.error("Error parsing saved filter model:", e);
      }
    }
  }
  const getWorkFlowData = async () => {
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseAnaltics = await dispatch(getAnalyticsWorkflowResults({
        dynamicEndpoint: `${analyticsResultsGETEndipoint}/${userEmail}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseAnaltics?.meta?.requestStatus === 'fulfilled') {
        setTextAreaValue("");
        gridApi?.deselectAll();
        setRowData(responseAnaltics?.payload?.records[0]);
        getFilterUpdateData(responseAnaltics?.payload?.records[0]);
        checkVariantFilter();
      } else {
        console.error('Failed to fetch data:', responseAnaltics?.error);
        toast.error(responseAnaltics?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const getFilterUpdateData = (data) => {
    const mapRow = (row, index) => {
      const finalLt =
        row.recomConfidenceLevel === "75%"
          ? row.likelyFinalLt || 0
          : row.recomConfidenceLevel === "65%"
            ? row.lessLikelyFinalLt || 0
            : row.highLikelyFinalLt || 0;

      const currLt = Number(
        row?.purchDocType === "Y1"
          ? row?.contractLt?.split(" ")[0]
          : row?.activePirLt?.split(" ")[0]
      );

      const ratio = Math.sqrt(Number(finalLt) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

      const inventoryChange =
        (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
        row?.currentAvgStock;

      let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

      return {
        ...row,
        finalLt,
        potentialImpact,
        inventoryValue,
        index,
      };
    };

    if (activeItem === "Pending Action") {
      const sortedFilterData = data?.pendingActionItems
        ?.map(mapRow)
        ?.sort((a, b) => variationRanking[b.ltVariations] - variationRanking[a.ltVariations]);
      setFilteredData(sortedFilterData);
    }

    if (activeItem === "Pending Approval") {
      setFilteredData(data?.pendingApprovalItems?.map(mapRow));
    }

    if (activeItem === "Closed Workflow Items") {
      setFilteredData(data?.closedWorkflowItems?.map(mapRow));
    }
  };

  const mapRowWithCalculations = (row) => {
    const finalLt =
      row.recomConfidenceLevel === "75%"
        ? row.likelyFinalLt || 0
        : row.recomConfidenceLevel === "65%"
          ? row.lessLikelyFinalLt || 0
          : row.highLikelyFinalLt || 0;

    const currLt = Number(
      row?.purchDocType === "Y1"
        ? row?.contractLt?.split(" ")[0]
        : row?.activePirLt?.split(" ")[0]
    );

    const ratio = Math.sqrt(Number(finalLt) / currLt);
    const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

    const inventoryChange =
      (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
      row?.currentAvgStock;

    let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

    return {
      ...row,
      finalLt,
      potentialImpact,
      inventoryValue,
    };
  };

  const pendingActionData = rowData?.pendingActionItems?.map(mapRowWithCalculations);
  const pendingApprovalData = rowData?.pendingApprovalItems?.map(mapRowWithCalculations);
  const closedData = rowData?.closedWorkflowItems?.map(mapRowWithCalculations);

  const pagination = true;
  const paginationPageSize = 500;
  const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
  const navigate = useNavigate();

  const onGridReady = (params) => {
    setGridApi(params?.api);
    gridRef.current = params.api;

    if (typeof (fromDetails) !== "string") {
      params.api.setFilterModel({
        ltVariations: {
          filterType: 'multi',
          filterModels: [
            {
              filterType: 'text',
              type: 'contains',
              filter: landingCardTitle === "Medium LT Variation" ? "Medium" : landingCardTitle === "Low LT Variation" ? "Low" : landingCardTitle === "High LT Variation" ? "High" : ""
            }
          ]
        }
      });
    }
    if (typeof (fromDetails) === "string") {
      const savedFilters = localStorage.getItem('agGridSharedFilter');
      if (savedFilters) {
        params.api.setFilterModel(JSON.parse(savedFilters));
      }
      return;
    }
    // localStorage.removeItem("agGridSharedFilter");
    // const savedFilters = localStorage.getItem('agGridSharedFilter');
    // if (savedFilters) {
    //   params.api.setFilterModel(JSON.parse(savedFilters));
    // }
  }

  const getPlannerHideColumnsData = async () => {
    try {
      const responseHidePlannerData = await dispatch(getPlannerHideColumnsAPI({
        dynamicEndpoint: `${getLTPlannerHideColumnsEndpoint}/${userEmail}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseHidePlannerData?.meta?.requestStatus === 'fulfilled') {
        setSelectedColumns(responseHidePlannerData?.payload);
        setBadgeCount(responseHidePlannerData?.payload?.length);
        const hideDropdownOptions = regularItemsData?.filter((item) => item?.optionalField === true);
        setColumnFilterDropdownOption(hideDropdownOptions);
        const displayedColumns = regularItemsData.filter(
          col => !col.optionalField || !responseHidePlannerData?.payload?.includes(col.headerName)
        );
        setFilteredColumnsData([...displayedColumns]);
      } else {
        console.error('Failed to fetch data:', responseHidePlannerData?.error);
        toast.error(responseHidePlannerData?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }
  useEffect(() => {
    getPlannerHideColumnsData()

  }, [])

  const sortedItems = pendingActionData?.sort((a, b) => {
    return variationRanking[b.ltVariations] - variationRanking[a.ltVariations]
  })

  useEffect(() => {
    if (activeItem === "Pending Action") {
      setFilteredData(sortedItems);
    }
    else if (activeItem === "Pending Approval") {
      setFilteredData(pendingApprovalData)
    }
    else if (activeItem === "Closed Workflow Items") {
      setFilteredData(closedData)
    }
    setSelectedRows([]);
    setEditedRows([]);
    setTextAreaValue("")
  }, [activeItem, navigate, dispatch, role]);

  const onChangeConfidenceLevel = (params) => {
    // console.log("Entered ", params);
  }

  const cellEditorParams = {
    getPopUpPosition: () => "under",
    popup: true,
    editorStyle: {
      width: "60px"
    }

  }
  const getViewAllData = async (row) => {
    try {
      const responseViewAllDetails = await dispatch(getViewAllDetails({
        dynamicEndpoint: `${getViewAllDetailsEndpoint}/${row.runSeqId}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
        setViewAllData(responseViewAllDetails?.payload)
      } else {
        console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
        toast.error(responseViewAllDetails?.payload?.errorMessage, {
          autoClose: 2000,
        });
        setViewAllData({})
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }
  const handleOpenViewAllModal = (row) => {
    setOpenViewAllModal(true);
    getViewAllData(row);
  }
  const handleCloseViewAllModal = (row) => {
    setOpenViewAllModal(false);
    setViewAllData({})
  }
  const handleOpenLineGraphModal = (row) => {
    setOpenLineGraph(true);
    setLineGraphSelectedValue(row)
  }
  const handleCloseLineGraphModal = () => {
    setOpenLineGraph(false);
  }
  const handleSaveLineGraphModal = (row) => {
    setOpenLineGraph(false);
    const currentAvgStock = Number(lineGraphSelectedValue?.currentAvgStock || 0);
    const oldSafetyStock = Number(lineGraphSelectedValue?.oldSafetyStock || 0);
    const leadTime = Number(row?.leadTime || 0);
    const currLt = Number(
      lineGraphSelectedValue?.purchDocType === "Y1"
        ? lineGraphSelectedValue?.contractLt?.split(" ")[0]
        : lineGraphSelectedValue?.activePirLt?.split(" ")[0]
    );

    const ratio = currLt !== 0 ? Math.sqrt(leadTime / currLt) : 0;
    const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

    const inventoryChange = (currentAvgStock - oldSafetyStock + (oldSafetyStock * ratio)) - currentAvgStock;

    let inventoryValue = (lineGraphSelectedValue.actualPrice * inventoryChange).toFixed(2);

    const updatedRow = { ...lineGraphSelectedValue, inventoryValue: inventoryValue, recomConfidenceLevel: row.percentile, finalLt: Number(row.leadTime), graphFinalLT: Number(row.leadTime), potentialImpact: `${Math.round((Math.sqrt(Number(row.leadTime) / Number(lineGraphSelectedValue?.purchDocType === "Y1" ? lineGraphSelectedValue?.contractLt?.split(" ")[0] : lineGraphSelectedValue?.activePirLt?.split(" ")[0])) - 1) * 100)}%` }
    const getArray = [updatedRow];
    getArray.forEach((updatedRow) => {
      const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
      node.setData(updatedRow);
    });
    setSelectedRows((prevSelected) =>
      prevSelected.map(item =>
        item.runOutputSeqId === updatedRow.runOutputSeqId ? updatedRow : item
      )
    );
  }

  const handleOpenOutboundModal = (row, name) => {
    setOpenOutboundModal(true);
    setOutboundData(row);
    setSelectedName(name)
  }
  const handleCloseOutboundModal = (row) => {
    setOpenOutboundModal(false);
    setOutboundData({});
  }
  const handleOpenLeadTime = (row, name) => {
    setOpenLeadTimeModal(true);
    setLeadTimeData(row);
    setLeadTimeName(name)
  }
  const handleCloseLeadTime = (row) => {
    setOpenLeadTimeModal(false);
    setLeadTimeData({});
  }

  const regularItemsData = activeItem === "Pending Action" ? PendingActionHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenLineGraphModal, handleOpenLeadTime) : activeItem === "Pending Approval" ? PendingApprovalHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenLineGraphModal, handleOpenLeadTime) : ClosedWorkflowHeaders(onChangeConfidenceLevel, navigate, getWorkFlowData, activeItem, state, role, handleOpenViewAllModal, handleOpenOutboundModal, handleOpenLeadTime)
  const [filteredColumnsData, setFilteredColumnsData] = useState(regularItemsData);
  useEffect(() => {
    getPlannerHideColumnsData();
  }, [activeItem]);

  const cardData = [
    {
      title: "Pending Action",
      value: pendingActionData?.length
    },
    { title: "Pending Approval", value: pendingApprovalData?.length },
    { title: "Closed Workflow Items", value: closedData?.length },
  ];
  const callBackFunction = (index, title, url) => {
    setActiveItem(title);
    // clearAllFilters();
    localStorage.setItem("workflowActiveItem", title);
    localStorage.setItem("lastVisitedPage", 0);
    currentPageRef.current = 0;
    gridRef.current.paginationGoToPage(0);
  }
  const hasSpecifiedKeyValue = (arr, key, value) => {
    if (!arr) {
      return false;
    }
    if (arr) {
      return arr.every(obj => obj[key] === value);
    }
  };

  const isFinalLtEditable = (row) => {
    if (!row) return false;
    if (role === "Admin") return false;
    if (activeItem === "Pending Approval") {
      return row?.currentApprovalLevel === 0;
    }
    if (activeItem === "Pending Action") {
      return true;
    }
    return false;
  };

  const onSelectionChanged = (params) => {
    const filteredSelectedRows = [];
    params?.api?.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        filteredSelectedRows.push(node.data);
      }
    });
    setSelectedRows(filteredSelectedRows);
    dispatch(setSelectedItem(filteredSelectedRows));
    const reCallDisabledCount = filteredSelectedRows?.filter(row => (row?.currentApprovalLevel === 0));
    setReCallDisabled(reCallDisabledCount?.length > 0)
    const rejectDisabledCount = filteredSelectedRows?.filter(row => (row?.currentApprovalLevel !== 0));
    setRejectDisabled(rejectDisabledCount?.length > 0)
    const result = filteredSelectedRows?.length > 0 ? hasSpecifiedKeyValue(filteredSelectedRows, 'ltVariations', 'Low') : false;
    setIsSubmitToS4Enabled(!result);
    const hasEditableFinalLtRows = filteredSelectedRows.length > 0 && filteredSelectedRows.some(isFinalLtEditable);
    setBulkPDTDisabled(!hasEditableFinalLtRows);
    if (hasEditableFinalLtRows) {
      bulkPDTBaseRowsRef.current = filteredSelectedRows
        .filter(isFinalLtEditable)
        .map((row) => ({ ...row }));
    } else {
      setBulkPDTValue("");
      bulkPDTBaseRowsRef.current = [];
    }
  }

  const rowSelection = useMemo(() => {
    if (activeItem === "Pending Action") {
      if (role === "Planner") {
        return {
          mode: 'multiRow',
        }
      } else {
        return undefined;
      }
    }
    if (activeItem === "Pending Approval") {
      if (role === "Planner") {
        return {
          mode: 'multiRow',
          // isRowSelectable: (rowNode) => rowNode?.data?.currentApprovalLevel === 0,
        }
      } else {
        return undefined;
      }
    }
    if (activeItem === "Closed Workflow Items") {
      return undefined;
    }
  })
  const selectionColumnDef = useMemo(() => ({
    pinned: 'left'
  }))

  const clearAllFilters = () => {
    if (gridRef.current) {
      gridRef.current.setFilterModel(null);
      setDisableFilterBtn(true);
    }
    localStorage.removeItem('agGridSharedFilter');
    localStorage.removeItem("savedVariantFilterModel");
  };

  const onFilterChanged = () => {
    if (gridRef.current) {
      const filterModel = gridRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0);
      localStorage.setItem('agGridSharedFilter', JSON.stringify(filterModel));
    }
  };

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.runOutputSeqId}`
    },
    onFilterChanged,
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressMiniFilter: false,
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              excelMode: 'windows',
              suppressMiniFilter: false,
              buttons: ['apply', 'reset'],
            },
          },
        ],
      },
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === "" ? "-" : value;
      },
    }

  }
  useEffect(() => {
    checkVariantFilter()
  }, [gridApi]);

  const handleCreateVariantModal = () => {
    setVariantData(gridApi?.getFilterModel());
    setOpenCreateVariantModal(true);
  }

  const handleCloseCreateVariantModal = () => {
    setOpenCreateVariantModal(false)
  }
  const handleShowVariantModal = () => {
    setOpenShowVariantModal(true);
  }

  const handleCloseShowVariantModal = () => {
    setOpenShowVariantModal(false)
  }
  const onClickSelectVariant = (variant) => {
    if (!gridApi || !variant?.filterJson) return;

    try {
      const filterModel =
        typeof variant.filterJson === "string"
          ? JSON.parse(variant.filterJson)
          : variant.filterJson;

      localStorage.setItem("savedVariantFilterModel", JSON.stringify(filterModel));
      gridApi.setFilterModel(filterModel);
      gridApi.onFilterChanged();
    } catch (e) {
      console.error("Invalid filterJson:", variant.filterJson, e);
    }
  };
  const onPaginationChanged = () => {

    if (gridRef.current && !gridRef.current.isDestroyed()) {
      const currentPage = gridRef.current.paginationGetCurrentPage();
      currentPageRef.current = currentPageRef.current || currentPage;
      localStorage.setItem("lastVisitedPage", currentPage);
    }
  };
  const onFirstDataRendered = () => {
    if (gridRef.current && !gridRef.current.isDestroyed()) {
      gridRef.current.paginationGoToPage(currentPageRef.current || 0);
      localStorage.setItem("lastVisitedPage", currentPageRef.current);
    }
  };
  const onCellValueChanged = (params) => {
    const { colId } = params.column;
    const { data } = params;
    if (selectedRows.some(row => row.runOutputSeqId === params.data.runOutputSeqId)) {
      const updatedSelectedRows = selectedRows.map(row =>
        row.runOutputSeqId === params.data.runOutputSeqId ? params.data : row
      );
      setSelectedRows(updatedSelectedRows);
    }

    if (colId === "finalLt") {
      const currLt = Number(
        params?.data?.purchDocType === "Y1"
          ? params?.data?.contractLt?.split(" ")[0]
          : params?.data?.activePirLt?.split(" ")[0]
      );
      const ratio = Math.sqrt(Number(params?.data?.finalLt || 0) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

      const inventoryChange =
        (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratio)) -
        params?.data?.currentAvgStock;

      let inventoryValue = (params?.data?.actualPrice * inventoryChange).toFixed(2);
      params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.finalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
      params.node.setDataValue('inventoryValue', inventoryValue);
      setEditedRows((prevEditedRows) => {
        const existingRowIndex = prevEditedRows.findIndex(row => row.runOutputSeqId === data.runOutputSeqId);
        if (existingRowIndex > -1) {
          const updatedEditedRows = [...prevEditedRows];
          updatedEditedRows[existingRowIndex] = data;
          return updatedEditedRows;
        } else {
          return [...prevEditedRows, data];
        }
      });
    }
    if (colId === 'recomConfidenceLevel') {
      const currLt = Number(
        params?.data?.purchDocType === "Y1"
          ? params?.data?.contractLt?.split(" ")[0]
          : params?.data?.activePirLt?.split(" ")[0]
      );
      const ratioLikely = Math.sqrt(Number(params?.data?.likelyFinalLt || 0) / currLt);
      const ratioLessLikely = Math.sqrt(Number(params?.data?.lessLikelyFinalLt || 0) / currLt);
      const ratioHighLikely = Math.sqrt(Number(params?.data?.highLikelyFinalLt || 0) / currLt);
      if (params.data.recomConfidenceLevel === "75%") {
        const inventoryChangeLikely =
          (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioLikely)) -
          params?.data?.currentAvgStock;
        let inventoryValueLikely = (params?.data?.actualPrice * inventoryChangeLikely).toFixed(2);

        params.node.setDataValue('finalLt', params?.data?.likelyFinalLt);
        params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.likelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
        params.node.setDataValue('inventoryValue', inventoryValueLikely);
      } else if (params.data.recomConfidenceLevel === "65%") {
        const inventoryChangeLessLikely =
          (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioLessLikely)) -
          params?.data?.currentAvgStock;
        let inventoryValueLessLikely = (params?.data?.actualPrice * inventoryChangeLessLikely).toFixed(2);
        params.node.setDataValue('finalLt', params?.data?.lessLikelyFinalLt);
        params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.lessLikelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
        params.node.setDataValue('inventoryValue', inventoryValueLessLikely);
      } else if (params.data.recomConfidenceLevel === "85%") {
        const inventoryChangeHighLikely =
          (params?.data?.currentAvgStock - params?.data?.oldSafetyStock + (params?.data?.oldSafetyStock * ratioHighLikely)) -
          params?.data?.currentAvgStock;
        let inventoryValueHighLikely = (params?.data?.actualPrice * inventoryChangeHighLikely).toFixed(2);
        params.node.setDataValue('finalLt', params?.data?.highLikelyFinalLt);
        params.node.setDataValue('potentialImpact', `${Math.round((Math.sqrt(Number(params?.data?.highLikelyFinalLt || 0) / Number(params?.data?.purchDocType === "Y1" ? params?.data?.contractLt?.split(" ")[0] : params?.data?.activePirLt?.split(" ")[0])) - 1) * 100)}%`);
        params.node.setDataValue('inventoryValue', inventoryValueHighLikely);
      }
    }
  };

  const handleAddBulkPDT = (event) => {
    const value = event.target.value;
    setBulkPDTValue(value);

    const numericValue = Number(value);
    if (value === "" || Number.isNaN(numericValue)) {
      if (value === "") {
        const restoredRows = selectedRows.map((row) => {
          if (!isFinalLtEditable(row)) {
            return row;
          }

          const baseRow = bulkPDTBaseRowsRef.current.find(
            (base) => base.runOutputSeqId === row.runOutputSeqId
          ) || row;

          const currLt = Number(
            row?.purchDocType === "Y1"
              ? row?.contractLt?.split(" ")[0]
              : row?.activePirLt?.split(" ")[0]
          );
          const ratio = Math.sqrt(Number(baseRow?.finalLt || 0) / currLt);
          const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;
          const inventoryChange =
            (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
            row?.currentAvgStock;
          const inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

          return {
            ...row,
            finalLt: Number(baseRow?.finalLt || 0),
            potentialImpact,
            inventoryValue,
          };
        });

        setSelectedRows(restoredRows);
        restoredRows.forEach((restoredRow) => {
          if (!isFinalLtEditable(restoredRow) || !gridApi) {
            return;
          }
          const node = gridApi.getRowNode(restoredRow.runOutputSeqId);
          if (node) {
            node.setData(restoredRow);
          }
        });
      }
      return;
    }

    const updatedSelectedRows = selectedRows.map((row) => {
      if (!isFinalLtEditable(row)) {
        return row;
      }

      const baseRow = bulkPDTBaseRowsRef.current.find(
        (base) => base.runOutputSeqId === row.runOutputSeqId
      ) || row;

      // const currentFinalLt = Number(baseRow?.finalLt || 0);
      // const newFinalLt = currentFinalLt + numericValue;
      const newFinalLt = numericValue;
      const currLt = Number(
        row?.purchDocType === "Y1"
          ? row?.contractLt?.split(" ")[0]
          : row?.activePirLt?.split(" ")[0]
      );
      const ratio = Math.sqrt(Number(newFinalLt || 0) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;
      const inventoryChange =
        (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
        row?.currentAvgStock;
      const inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

      return {
        ...row,
        finalLt: newFinalLt,
        potentialImpact,
        inventoryValue,
      };
    });

    setSelectedRows(updatedSelectedRows);
    setEditedRows((prevEditedRows) => {
      const updatedEditedRows = [...prevEditedRows];
      updatedSelectedRows.forEach((updatedRow) => {
        const existingRowIndex = updatedEditedRows.findIndex(row => row.runOutputSeqId === updatedRow.runOutputSeqId);
        if (existingRowIndex > -1) {
          updatedEditedRows[existingRowIndex] = updatedRow;
        } else {
          updatedEditedRows.push(updatedRow);
        }
      });
      return updatedEditedRows;
    });

    updatedSelectedRows.forEach((updatedRow) => {
      if (!isFinalLtEditable(updatedRow) || !gridApi) {
        return;
      }
      const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
      if (node) {
        node.setData(updatedRow);
      }
    });
  };

  const closeFinalLTUpdateModal = () => {
    setOpenFinalLTUpdateModal(false)
  }
  const onClickFinalLTUpdateSubmitButton = (finalLTValue) => {

    setOpenFinalLTUpdateModal(false);
    const updatedSelectedRows = selectedRows.map(row => {

      const currLt = Number(
        row?.purchDocType === "Y1"
          ? row?.contractLt?.split(" ")[0]
          : row?.activePirLt?.split(" ")[0]
      );

      const ratio = Math.sqrt(Number(finalLTValue) / currLt);
      const potentialImpact = `${Math.round((ratio - 1) * 100)}%`;

      const inventoryChange =
        (row?.currentAvgStock - row?.oldSafetyStock + (row?.oldSafetyStock * ratio)) -
        row?.currentAvgStock;

      let inventoryValue = (row?.actualPrice * inventoryChange).toFixed(2);

      const updatedRow = { ...row, finalLt: Number(finalLTValue), potentialImpact: potentialImpact, inventoryValue }
      return updatedRow;
    });
    updatedSelectedRows.forEach((updatedRow) => {
      const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
      node.setData(updatedRow);
    });
    gridApi.deselectAll();
    updatedSelectedRows.forEach((updatedRow) => {
      const node = gridApi.getRowNode(updatedRow.runOutputSeqId);
      node.setSelected(true);
    });
    setEditedRows(updatedSelectedRows)
  }

  const onClickSendToS4Handler = async () => {
    const userEmail = localStorage.getItem("data");
    const arrSendToS4 = [];
    selectedRows.map((item) => {
      arrSendToS4.push({
        "runOutputSeqId": item.runOutputSeqId,
        "userLt": item.finalLt,
        "confidenceLevel": item.recomConfidenceLevel,
        "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
      })
    })

    const sendToS4RequestBody = {
      "userEmail": userEmail,
      "outputReviewList": arrSendToS4,
      "userRemarks": textAreaValue
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSendtoLowMaterials = await dispatch(postSendLowMaterials({
        dynamicEndpoint: `${sendToLowMaterialsEndpoint}`,
        data: sendToS4RequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSendtoLowMaterials.meta.requestStatus === 'fulfilled') {
        toast.success(responseSendtoLowMaterials?.payload, {
          autoClose: 2000,
        });
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseSendtoLowMaterials?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }

  const onClickRejectHandler = async () => {

    const userEmail = localStorage.getItem("data");
    const arr = [];
    selectedRows.map((item) => {
      arr.push({
        "runOutputSeqId": item.runOutputSeqId,
        "userLt": item.finalLt,
        "confidenceLevel": item.recomConfidenceLevel,
        "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
      })
    })

    const rejectRequestBody = {
      "userEmail": userEmail,
      "outputReviewList": arr,
      "userRemarks": textAreaValue
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseRejectWorkflow = await dispatch(postRejectWorkflow({
        dynamicEndpoint: `${rejectWorkflowEndpoint}`,
        data: rejectRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseRejectWorkflow.meta.requestStatus === 'fulfilled') {
        toast.success(responseRejectWorkflow?.payload, {
          autoClose: 2000,
        });
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseRejectWorkflow?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const sendForApprovalAPI = async (approversData, comments) => {
    const userEmail = localStorage.getItem("data");
    const arr = [];
    selectedRows.map((item) => {
      arr.push({
        "runOutputSeqId": item.runOutputSeqId,
        "userLt": item.finalLt,
        "confidenceLevel": item.recomConfidenceLevel,
        "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
      })
    })

    const approversList = [];
    approversData.map((item) => {
      approversList.push({
        "approverEmail": item.email,
        "approverName": item.name,
        "approverLevel": item.level
      },)
    })

    const sendForApprovalRequestBody = {
      "userEmail": userEmail,
      "userRemarks": comments,
      "outputReviewList": arr,
      "approversList": approversList
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSendForApproval = await dispatch(postSendForApproval({
        dynamicEndpoint: `${sendForApprovalEndpoint}`,
        data: sendForApprovalRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSendForApproval.meta.requestStatus === 'fulfilled') {
        toast.success(responseSendForApproval?.payload, {
          autoClose: 2000,
        });
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseSendForApproval?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }

  const RecallAPI = async () => {
    const userEmail = localStorage.getItem("data");
    const arr = [];
    selectedRows.map((item) => {
      arr.push({
        "runOutputSeqId": item.runOutputSeqId,
        "userLt": item.finalLt,
        "level": 0,
        "confidenceLevel": item.recomConfidenceLevel,
        "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
      })
    })
    const recallRequestBody = {
      "userEmail": userEmail,
      "userRemarks": textAreaValue,
      "updateWorkflowsList": arr
    }

    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseRecall = await dispatch(postRecallAPI({
        dynamicEndpoint: `${recallPlannerEndpoint}`,
        data: recallRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseRecall.meta.requestStatus === 'fulfilled') {
        toast.success(responseRecall?.payload, {
          autoClose: 2000,
        });
        setBulkPDTDisabled(true);
        setBulkPDTValue("");
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseRecall?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

  }

  const ResubmitForApprovalAPI = async () => {
    const userEmail = localStorage.getItem("data");
    const arr = [];
    selectedRows.map((item) => {
      arr.push({
        "runOutputSeqId": item.runOutputSeqId,
        "userLt": item.finalLt,
        "level": 0,
        "confidenceLevel": item.recomConfidenceLevel,
        "recommendedLt": item.recomConfidenceLevel === "85%" ? item.highLikelyFinalLt : item?.graphFinalLT || item.finalLt
      })
    })

    const reSubmitForApprovalRequestBody = {
      "userEmail": userEmail,
      "userRemarks": textAreaValue,
      "updateWorkflowsList": arr
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseReSubmitWorkflow = await dispatch(postResubmitWorkflow({
        dynamicEndpoint: `${reSubmitWorkflowEndpoint}`,
        data: reSubmitForApprovalRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseReSubmitWorkflow.meta.requestStatus === 'fulfilled') {
        toast.success(responseReSubmitWorkflow?.payload, {
          autoClose: 2000,
        });
        setBulkPDTValue("");
        setBulkPDTDisabled(true);
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseReSubmitWorkflow?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const editApproversAPI = async (approversData) => {
    const userEmail = localStorage.getItem("data");
    const runOutputSeqId = selectedRows[0]?.runOutputSeqId;
    const approversList = [];
    approversData.map((item) => {
      approversList.push({
        "approverEmail": item.email,
        "approverName": item.name,
        "approverLevel": item.level
      },)
    })

    const editApproversRequestBody = {
      "userEmail": userEmail,
      "runOutputSeqId": runOutputSeqId,
      "approversList": approversList
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseEditApprovers = await dispatch(putEditApproversWorkflow({
        dynamicEndpoint: `${editApproversWorkflowEndpoint}`,
        data: editApproversRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseEditApprovers.meta.requestStatus === 'fulfilled') {
        toast.success(responseEditApprovers?.payload, {
          autoClose: 2000,
        });
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseEditApprovers?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const reAssignSubmitAPI = async (selectedName, selectedEmailId, reAssignComments) => {
    const userEmail = localStorage.getItem("data");
    const reAssignArr = [];
    selectedRows.map((item) => {
      reAssignArr.push(item.runOutputSeqId)
    })

    const reAssignRequestBody = {
      "userEmail": userEmail,
      "userRemarks": reAssignComments,
      "assigneeName": selectedName,
      "assigneeEmail": selectedEmailId,
      "runOutputSeqIdList": reAssignArr
    }
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseReassignToOthers = await dispatch(postReassignToOthers({
        dynamicEndpoint: `${reAssignToOthersEndpoint}`,
        data: reAssignRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseReassignToOthers.meta.requestStatus === 'fulfilled') {
        toast.success(responseReassignToOthers?.payload, {
          autoClose: 2000,
        });
        setTextAreaValue("");
        setSelectedRows([]);
        setEditedRows([])
        getWorkFlowData();
      } else {
        toast.error(responseReassignToOthers?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }
  const handleTextAreaChange = (e) => {
    setTextAreaValue(e.target.value);
  }

  const handleColumnChange = (event) => {
    setSelectedColumns(event.target.value);
  };

  const renderDropdownValue = (selected) => {
    if (selected?.length === 0) return "Select Columns";
    if (selected?.length === 1) return columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;

    const firstColumnName = columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
    return `${firstColumnName}, +${selected?.length - 1}`;
  };

  const handleSave = async () => {

    const responseBody = {
      "userEmail": userEmail,
      "hiddenColumns": selectedColumns
    }

    try {
      const responsePostPlannerHideColumns = await dispatch(postPlannerHideColumnsAPI({
        dynamicEndpoint: `${postLTPlannerHideColumnsEndpoint}`,
        data: responseBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responsePostPlannerHideColumns?.meta?.requestStatus === 'fulfilled') {
        getPlannerHideColumnsData();
        handleCloseHide();
      } else {
        console.error('Failed to fetch data:', responsePostPlannerHideColumns?.error);
        toast.error(responsePostPlannerHideColumns?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }

    const displayedColumns = regularItemsData.filter(
      col => !col.optionalField || !selectedColumns.includes(col.headerName)
    );
    setFilteredColumnsData([...displayedColumns]);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickHide = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseHide = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    (stateSelector?.AnalyticsWorkflowResultsSlice?.loading || stateSelector?.SendToS4MaterialsSlice.loading || stateSelector?.RejectWorkflowSlice.loading || stateSelector?.SendForApprovalSlice.loading | stateSelector?.ReassignToOthersSlice.loading || stateSelector?.ResubmitWorkflowSlice.loading || stateSelector?.RecallSlice?.loading) ?
      <Loader />
      :
      <div>
        <TopSection tabTitle="Workflow Management" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'Analytics Results' }]} />
        <div className="card_container">
          <Cards cards={cardData} showBorder={true} callBackFunction={callBackFunction} />
        </div>
        <div><p id="activeItem_Workflow">{activeItem}</p></div>
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "6px",
            padding: "10px",
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '5px 0px 10px 0px' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: 10 }}>
                <IconButton onClick={handleClickHide}>
                  <Badge badgeContent={badgeCount > 0 ? badgeCount : null} sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem", // Smaller font size
                      height: "16px", // Adjust badge height
                      minWidth: "16px", // Adjust badge width
                      padding: "4px", // Adjust padding
                      background: '#000',
                      color: '#fff'
                    },
                  }}
                  >
                    <MoreVertIcon />
                  </Badge>
                </IconButton>

                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleCloseHide}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  className="hidePopover"
                  sx={{
                    marginTop: 1,
                    marginLeft: 0,
                  }}
                >
                  <div style={{ padding: 10, width: 150 }}>
                    <p style={{ marginBottom: 10, marginTop: 5 }}>Hide Columns</p>
                    <Select
                      multiple
                      value={selectedColumns}
                      onChange={handleColumnChange}
                      renderValue={renderDropdownValue}
                      displayEmpty
                      sx={{ backgroundColor: "#fff", border: '1px solid #000', width: '100%', height: 35, marginBottom: 5 }}
                    >
                      <MenuItem disabled value="">
                        <em>Select Columns</em>
                      </MenuItem>
                      {columnFilterDropdownOption?.map(col => (
                        <MenuItem key={col.headerName} value={col.headerName}>
                          <Checkbox checked={selectedColumns?.includes(col.headerName)} />
                          <ListItemText primary={col.headerName} />
                        </MenuItem>
                      ))}
                    </Select>
                    {stateSelector?.PostPlannerHideColumns?.loading ?
                      <Box style={{ textAlign: 'center' }}>
                        <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center' }} />
                      </Box>
                      :
                      <ButtonComponent type="secondary" label="Save" onClick={handleSave} />
                    }
                  </div>
                </Popover>
              </div>
              <div style={{ display: 'flex', justifyContent: 'end', gap: 10 }}>
                <ButtonComponent
                  maxWidth="150px"
                  label="Clear All Filters"
                  bgColor="black"
                  color="white"
                  disabled={disableFilterBtn}
                  onClick={clearAllFilters}
                />
                <ButtonComponent
                  maxWidth="180px"
                  label="Create/Edit Variant"
                  bgColor="black"
                  color="white"
                  // disabled={Object.keys(gridApi?.getFilterModel() || {}).length === 0}
                  onClick={handleCreateVariantModal}
                />
                <ButtonComponent
                  maxWidth="150px"
                  label="Show Variants"
                  bgColor="black"
                  color="white"
                  onClick={handleShowVariantModal}
                />
                {
                  role !== "Admin" &&
                  <TextInput
                    name="bulkPDTValue"
                    type="number"
                    value={bulkPDTValue}
                    onChange={handleAddBulkPDT}
                    label="Bulk PDT"
                    width="150px"
                    disabled={bulkPDTDisabled}
                  />
                }
              </div>
            </div>
            {activeItem !== "Closed Workflow Items" && role !== "Admin" &&
              <div style={{ display: 'flex', justifyContent: 'end', margin: '5px 0px 10px 0px' }}>
                <span style={{ fontSize: 14, textDecoration: 'underline', cursor: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "auto" : 'pointer', color: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "#bcbcbc" : "#000" }} onClick={() => selectedRows?.length !== 0 && setOpenFinalLTUpdateModal(true)}>LT to be updated against selected items</span>
                <FinalLTUpdateModal openFinalLTUpdateModal={openFinalLTUpdateModal} closeFinalLTUpdateModal={closeFinalLTUpdateModal} onClickSubmitButton={onClickFinalLTUpdateSubmitButton} />
              </div>}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div>
              {filteredData && <DataTable
                ref={gridRef}
                columns={filteredColumnsData}
                rows={filteredData || []}
                paginationProp={pagination}
                paginationPageSize={paginationPageSize}
                paginationPageSizeSelector={paginationPageSizeSelector}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
                headerCheckboxSelectionFilterOnly={true}
                rowSelection={rowSelection}
                selectionColumnDef={selectionColumnDef}
                gridOptions={gridOptions}
                cellEditorParams={cellEditorParams}
                stopEditingWhenCellsLoseFocus={true}
                onCellValueChanged={onCellValueChanged}
                onPaginationChanged={onPaginationChanged}
                onFirstDataRendered={onFirstDataRendered}
              />}
            </div>
            <div>
              <VariantViewModal tableType={"LT_PLANNER"} openCreateVariantModal={openCreateVariantModal} handleCloseCreateVariantModal={handleCloseCreateVariantModal} data={variantData} />
            </div>
            <div>
              <ShowVariantViewModal tableType={"LT_PLANNER"} openShowVariantModal={openShowVariantModal} handleCloseShowVariantModal={handleCloseShowVariantModal} data={variantData} onClickSelectVariant={onClickSelectVariant} />
            </div>
            <div>
              <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
            </div>
            <div>
              <LeadTimeLineGraph openLineGraph={openLineGraph} lineGraphSelectedValue={lineGraphSelectedValue} handleCloseLineGraphModal={handleCloseLineGraphModal} handleSaveModal={handleSaveLineGraphModal} />
            </div>
            <div>
              <OutBoundDataModal data={outboundData} selectedName={selectedName} openOutboundModal={openOutboundModal} handleCloseOutboundModal={handleCloseOutboundModal} />
            </div>
            <div>
              <CPLeadTimeModal data={leadTimeData} leadTimeName={leadTimeName} openLeadTimeModal={openLeadTimeModal} handleCloseLeadTime={handleCloseLeadTime} />
            </div>
            {(activeItem !== "Closed Workflow Items" && role !== "Admin") &&
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <span style={{ fontSize: 12 }}>Remarks for Acceptance/Rejection*</span>
                <TextareaAutosize disabled={selectedRows?.length === 0 || selectedRows?.length === undefined} minRows={3} style={{ width: '300px', fontSize: 14 }} onChange={handleTextAreaChange} value={textAreaValue} />
              </div>}
          </div>
        </div>
        {
          activeItem !== "Closed Workflow Items" && role !== "Admin" &&
          <div style={{ margin: '20px 0px', display: 'flex', gap: 10, justifyContent: "space-between" }}>
            <div>
              {activeItem === "Pending Action" &&
                <SendToS4Modal onClickSendToS4Handler={onClickSendToS4Handler} disabledSendToS4Button={isSubmitToS4Enabled || textAreaValue?.length === 0} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />
              }
              {activeItem === "Pending Approval" &&
                <ButtonComponent
                  maxWidth="200px"
                  label="Recall"
                  bgColor="Black"
                  color="white"
                  onClick={RecallAPI}
                  disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0 || reCallDisabled}
                />
              }
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: "end" }}>
              {activeItem === "Pending Action" && <ReAssignModal activeItem={activeItem} rowCount={selectedRows?.length} disableSendForApprovalButton={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0} textAreaValueForSend={textAreaValue} reAssignSubmitAPI={reAssignSubmitAPI} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />}
              {activeItem === "Pending Action" && <RejectWorkFlowItem onClickRejectHandler={onClickRejectHandler} disabledRejectButton={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />}
              {activeItem === "Pending Approval" && <RejectWorkFlowItem onClickRejectHandler={onClickRejectHandler} disabledRejectButton={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0 || rejectDisabled} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />}
              {activeItem === "Pending Action" && <SendForApprovalModal activeItem={activeItem} rowCount={selectedRows?.length} disableSendForApprovalButton={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0} textAreaValueForSend={textAreaValue} sendForApprovalAPI={sendForApprovalAPI} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />}
              {activeItem === "Pending Approval" &&
                <>
                  <EditApproversModalNew runOutputSeqId={selectedRows[0]?.runOutputSeqId} rowCount={selectedRows?.length} disableEditApproversButton={(selectedRows?.length !== 1 || selectedRows?.length === undefined || rejectDisabled)} editApproversAPI={editApproversAPI} setBulkPDTDisabled={setBulkPDTDisabled} setBulkPDTValue={setBulkPDTValue} />
                  <ButtonComponent
                    maxWidth="200px"
                    label="Resubmit for Approval"
                    bgColor="Black"
                    color="white"
                    onClick={ResubmitForApprovalAPI}
                    disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined) || textAreaValue?.length === 0 || rejectDisabled}
                  />
                </>
              }
            </div>
          </div>
        }
      </div >
  );
};

export default AnalyticsResults;
